import React, { PropTypes } from 'react';
import { ListGroup, ListGroupItem, Panel, Accordion } from 'react-bootstrap';
import { Link, IndexLink } from 'react-router';
import './LeftSideMenu.less';

class LeftSideMenu extends React.Component {
   render() {
      const { menuLinks } = this.props;
      return (
         <div className="LeftSideMenu" >
            <Accordion>
               {menuLinks.map((menu, index) => (
                  <Panel header={menu.name} key={index} eventKey={index + 1} >
                     <ListGroup>
                        {menu.links.map((link) => (
                           <ListGroupItem key={link.name} >
                              {link.to === ''
                                 ?
                                 <IndexLink to={'/' + link.to} activeStyle={{ color: 'red' }} >
                                    {link.name}</IndexLink>
                                 :
                                 <Link to={'/' + link.to}
                                       activeStyle={{ color: 'red' }} >
                                    {link.name}</Link>
                              }

                           </ListGroupItem>
                        ))}
                     </ListGroup>
                  </Panel>
               ))}
            </Accordion>
         </div>
      );
   }
}

LeftSideMenu.propTypes = {
   menuLinks: PropTypes.array.isRequired
};

export default LeftSideMenu;



/** WEBPACK FOOTER **
 ** ./src/components/LeftSideMenu/LeftSideMenu.js
 **/